import React from 'react';
import { InputNumber } from 'antd';
import type { InputNumberProps } from 'antd/lib/input-number';
import styled from 'types/theme.types';
import { getCommonInputCssFromProps } from 'components/common/input-components/common-styles';
import omit from 'lodash/omit';

export interface NumberInputProps extends InputNumberProps {
  invalid?: boolean;
}

const NumberInput: React.FC<NumberInputProps> = ({ ...props }) => <StyledNumberInput {...omit(props, ['hideError'])} />;

const StyledNumberInput = styled(InputNumber)<NumberInputProps>`
  height: 28px !important;
  ${getCommonInputCssFromProps}

  .ant-input-number-input {
    height: 28px !important;
    color: ${({ theme }) => theme.primaryBlack};
  }

  &.ant-input-number-disabled {
    background-color: ${({ theme }) => theme.primaryGray};
  }

  .ant-input-number-handler-down-inner {
    margin-top: 3px;
  }

  .ant-input-number-handler-up-inner {
    margin-top: -4px;
  }

  .ant-input-number-handler-wrap {
    background-color: ${({ theme }) => theme.primaryGray};
  }

  .ant-input-number-handler {
    border-color: ${({ theme }) => theme.primaryGray};
  }

  .ant-input-number-handler svg {
    fill: ${({ theme }) => theme.primaryBlack};
  }
`;

export default NumberInput;
